export default __webpack_public_path__ + "images/onboarding/B-b2eb144e6500844d3f67f09e614901da.svg";